import { render, staticRenderFns } from "./CreditorChip.vue?vue&type=template&id=1d9b4bf4&scoped=true"
import script from "./CreditorChip.vue?vue&type=script&lang=js"
export * from "./CreditorChip.vue?vue&type=script&lang=js"
import style0 from "./CreditorChip.vue?vue&type=style&index=0&id=1d9b4bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9b4bf4",
  null
  
)

export default component.exports